import React, { useEffect, useState } from "react";
import { ArrowRight, Search, ChevronUp, ChevronDown, ChevronsUpDown, Eye, EyeOff, Download, X, EllipsisVerticalIcon, QrCode, Info } from "lucide-react";
import TagCostInfoModal from "../../components/common/TagCostInfoModal";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import TextInput from "../../Commponent/TextInput";
import AgentFastagRequest from "../../Commponent/AgentFastagRequest";
import CustomSelectInput from "../../Commponent/SelectInput";
import { getVehicleClassData } from "../../Utils/helper";
import { vehicleClasses } from '../../Utils/Constants';
import CommonTable from "../../Common/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { ErrorToast, SuccessToast } from "../../Utils/toast";
import moment from "moment";
import { API } from "../../Common/Api";
import CommonTableModal from "../../Commponent/CommonTableModal";
import QRScannerModal from "../../components/common/QRScannerModal";
import { getRole } from "../../Utils/auth";

//Agent Inventory
const AgentInventory = () => {
  const dispatch = useDispatch();
  const GetInventoryAgent = useSelector((state) => state.GetInventoryAgent.GetInventoryAgentData);
  const GetAgentSummary = useSelector((state) => state.GetAgentSummary.GetAgentSummaryData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");
  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedVehicleClass, setSelectedVehicleClass] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  // Date-wise sort on the "Activated Date" column, on demand.
  const [activationDateSortEnabled, setActivationDateSortEnabled] = useState(false);
  const [activationDateSortOrder, setActivationDateSortOrder] = useState("desc"); // 'desc' = newest first, 'asc' = oldest first
  const [date, setDate] = useState(new Date());
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [inventoryData, setInventoryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkInventoryAgent, setCheckInventoryAgent] = useState(false);
  const [selectedTagRefId, setSelectedTagRefId] = useState(null);
  const [selectedTagActivated, setSelectedTagActivated] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState('cost');
  const [isScannerOpen, setScannerOpen] = useState(false);
  const [checkAgentSummary, setCheckAgentSummary] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [activationFilter, setActivationFilter] = useState("");

  const columns = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
  ];


  const columns1 = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
    { label: 'Delivery Date', accessor: 'DeliveryDate' },
    { label: 'Delivery Status', accessor: 'DeliveryStatus' },
  ];

  const data = [
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC4",
      Status: "Unassigned",
      PurchaseDate: "3 March, 2025",
      AssignedTo: "5 March, 2025",
      vehicleClass: 6,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC5",
      Status: "Unassigned",
      PurchaseDate: "30 March, 2025",
      AssignedTo: "1 March, 2025",
      vehicleClass: 5,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC6",
      Status: "Unassigned",
      PurchaseDate: "1 March, 2025",
      AssignedTo: "30 March, 2025",
      vehicleClass: 4,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    }
  ]
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : prev.direction === "desc" ? null : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc") return <ChevronUp className="w-[24px] h-[24px] inline-block ml-1 text-[#9C9C9C]" />;
      if (sortConfig.direction === "desc") return <ChevronDown className="w-[24px] h-[24px] inline-block ml-1 text-[#9C9C9C]" />;
    }
    return <ChevronDown className="w-[24px] h-[24px] inline-block ml-1 text-[#9C9C9C]" />;
  };

  // Toggles the "Activated Date" sort: off -> desc (newest first) -> asc -> desc ...
  const toggleActivationDateSort = () => {
    if (!activationDateSortEnabled) {
      setActivationDateSortEnabled(true);
      setActivationDateSortOrder("desc");
    } else {
      setActivationDateSortOrder((prev) => (prev === "desc" ? "asc" : "desc"));
    }
    setCurrentPage(1);
  };

  const ActivationDateSortIcon = () => {
    if (!activationDateSortEnabled) return <ChevronsUpDown className="w-3.5 h-3.5" />;
    return activationDateSortOrder === "desc" ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronUp className="w-3.5 h-3.5" />;
  };

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    setModalOpen(!isVisible);

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };


  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      // Only include filters that have values
      ...(serialNumber && { search: serialNumber }),
      ...(selectedVehicleClass && selectedVehicleClass !== '' && { VC: selectedVehicleClass }),
      ...(activationFilter && { isActivated: activationFilter }),
      // Date-wise sort on "Activated Date", once the user turns sorting on.
      ...(activationDateSortEnabled && { activationSort: 'true', activationSortOrder: activationDateSortOrder }),
    }
    setCheckInventoryAgent(true)
    dispatch(ACTIONS.GetInventoryAgentAction(params));
  }

  const handleScan = (serial) => {
    setSerialNumber(serial);
    setScannerOpen(false);
  }


  useEffect(() => {
    getData();
    // Fetch agent summary data on component mount
    setCheckAgentSummary(true);
    dispatch(ACTIONS.GetAgentSummaryAction());
  }, [serialNumber, selectedVehicleClass, currentPage, itemsPerPage, refreshCount, activationFilter, activationDateSortEnabled, activationDateSortOrder]);

  useEffect(() => {
    if (checkInventoryAgent) {
      if (GetInventoryAgent?.status == 200 && GetInventoryAgent?.success) {
        setInventoryData(GetInventoryAgent?.data.data);
      } else {
        ErrorToast(GetInventoryAgent?.message);
      }
      setCheckInventoryAgent(false)
      // setLoading(false);
    }
  }, [GetInventoryAgent])

  useEffect(() => {
    if (checkAgentSummary) {
      if (GetAgentSummary?.status == 200 && GetAgentSummary?.success) {
        setSummaryData(GetAgentSummary?.data);
      } else {
        console.log('Agent Summary Error:', GetAgentSummary?.message);
        ErrorToast(GetAgentSummary?.message);
      }
      setCheckAgentSummary(false);
    }
  }, [GetAgentSummary])

  // Dynamic summary stats from API data
  const summaryStats = (() => {
    if (!summaryData) {
      return [
        { label: "Total FASTag", value: 0, percent: 0, color: "#16a34a" },
        { label: "Activated FASTag", value: 0, percent: 0, color: "#FAB016" },
        { label: "Available FASTag", value: 0, percent: 0, color: "#2563eb" },
      ];
    }

    const total = summaryData.totalFastag?.count || 0;
    const calculatePercentage = (count) => {
      if (!total) return 0;
      const percentage = (count / total) * 100;
      return percentage > 100 ? 100 : percentage;
    };

    return [
      {
        label: "Total FASTag",
        value: total,
        percent: 100,
        color: "#16a34a"
      },
      {
        label: "Activated FASTag",
        value: summaryData.ActivatedFASTag?.count || 0,
        percent: calculatePercentage(summaryData.ActivatedFASTag?.count || 0),
        color: "#FAB016"
      },
      {
        label: "Available FASTag",
        value: summaryData.availableFASTag?.count || 0,
        percent: calculatePercentage(summaryData.availableFASTag?.count || 0),
        color: "#2563eb"
      },
    ];
  })();
  const agentData = [
    { name: "Karishma", phone: "+91 9945*****82", status: "Active", assigned: 1000, activated: 500 },
    { name: "Anjali", phone: "+91 9945*****82", status: "Active", assigned: 0, activated: "-" },
    { name: "Supriya", phone: "+91 9945*****82", status: "Deactivate", assigned: "N/A", activated: "–" },
    { name: "Vikas", phone: "+91 9945*****82", status: "Active", assigned: 200, activated: 20 },
    { name: "Deepa", phone: "+91 9945*****82", status: "Deactivate", assigned: "N/A", activated: 15000 },
  ];

  const agentNames = [...new Set(agentData.map((agent) => agent.name))];

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status) {
      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Activated</span>;
    }
    else {
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Available</span>;
    }
    return null;
  };

  const tableColumns = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => {
        const tagVal = item.tagRefId || item.serialNumber || '';
        const activated = item.isActivated === true || item.userActivationStatus === 'Active';
        return (
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-2">
              <span>{tagVal}</span>
              {tagVal && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedTagRefId(tagVal);
                    setSelectedTagActivated(activated);
                    setModalInitialTab('cost');
                  }}
                  className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-red-500 focus:outline-none"
                  title="View pricing details"
                >
                  <Info size={14} />
                </button>
              )}
            </div>
            {tagVal && activated && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedTagRefId(tagVal);
                  setSelectedTagActivated(true);
                  setModalInitialTab('transactions');
                }}
                className="text-xs font-medium text-blue-600 hover:underline text-left w-fit"
              >
                View Transactions
              </button>
            )}
          </div>
        );
      }
    },
    {
      label: "User Status",
      // isActivated is the one flag every activation path sets (mirrors the
      // Activated FASTag summary count). userMobileNumber is only written by
      // one specific activation flow, so tags activated any other way were
      // showing as "Available" here despite having a real activation date.
      render: (e, _) => <StatusBadge status={e.isActivated === true || e.userActivationStatus === 'Active'} />
    },
    {
      label: "Batch Id",
      key: "batchId",
    },
    {
      label: (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => handleSort("vehicleClass")}
        >
          Vehicle Class
          {/* {getSortIcon("vehicleClass")} */}
        </div>
      ),
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px] h-auto"
            />
            <p className="text-sm text-gray-700">{vehicleClassData?.value || "N/A"}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? (
                <Eye className="h-5 w-5 text-gray-400" />
              ) : (
                <EyeOff className="h-5 w-5 text-gray-400" />
              )}
            </div>
          </div>

        );
      },
    },
    // {
    //   label: "Assigned To",
    //   render: (item) => (
    //     item?.agentAssignedTo?.username ? (
    //       item?.agentAssignedTo?.username
    //     ) : (
    //       <button
    //         className="bg-red-500 text-white px-4 py-2 rounded-full text-xs font-semibold hover:bg-red-600"
    //         onClick={() => {
    //           setAssigningAgent(item); // Pass the whole agent/item object or just item.name as needed
    //           setIsModalOpen(true);
    //         }}
    //       >
    //         Assign +
    //       </button>
    //     )
    //   )
    // },
    // {
    //   label: "Assigned To",
    //   render: (item) => (
    //     item?.agentAssignedTo?.username || `N/A`
    //   )
    // },

    {
      label: "Assigned Date",
      key: "assignedDate",
      render: (item) => item?.agentAssignedDate ? moment(item.agentAssignedDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'
    },
    {
      label: (
        <div className="flex items-center gap-1">
          <span>Activated Date</span>
          <button
            onClick={(e) => { e.stopPropagation(); toggleActivationDateSort(); }}
            title="Sort by activation date"
            className="ml-0.5 text-[#EE3B31] hover:text-red-700 transition-colors focus:outline-none"
          >
            <ActivationDateSortIcon />
          </button>
        </div>
      ),
      key: "userActivationDate",
      render: (item) => item.userActivationDate ? moment(item.userActivationDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'
    },
    // { label: "Status", key: "status" },
  ];



  // const filteredInventory = inventoryData
  //   .filter(item => {
  //     const serialMatch = serialNumber === "" || item.serialNumber.toLowerCase().includes(serialNumber.toLowerCase());
  //     const agentMatch = selectedAgent === "" || item.assignedTo === selectedAgent;
  //     return serialMatch && agentMatch;
  //   })
  //   .sort((a, b) => {
  //     if (!sortConfig.key || !sortConfig.direction) return 0;
  //     const key = sortConfig.key;
  //     const direction = sortConfig.direction === "asc" ? 1 : -1;

  //     const valA = typeof a[key] === "number" ? a[key] : a[key]?.toString().toLowerCase();
  //     const valB = typeof b[key] === "number" ? b[key] : b[key]?.toString().toLowerCase();

  //     if (valA < valB) return -1 * direction;
  //     if (valA > valB) return 1 * direction;
  //     return 0;
  //   });

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);




  // Dedicated to the download button: the screen's other loading flags drive
  // the table overlay and a refetch, which a download must not trigger.
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      setCheckInventoryAgent(true);

      const params = {
        tab: 'agent',
        search: serialNumber,
        VC: selectedVehicleClass,
        isActivated: activationFilter,
      };

      const blob = await API.DownloadTabWiseExcel(params);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Agent_Inventory_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      SuccessToast("Excel file downloaded successfully");
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Excel file");
    } finally {
      setCheckInventoryAgent(false);
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="">
        {/* Summary Cards */}
        <div className="bg-[#FFFFFF] my-[30px] shadow-md rounded-xl p-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-800 mb-[16px] mt-[27.5px] f">Inventory Summary</h2>
            {/* <EllipsisVerticalIcon className="text-gray-500 hover:text-gray-700 text-2xl" /> */}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-[21px]">
            {summaryStats.map((item, idx) => (
              <div key={idx} className="bg-white rounded-xl p-4 shadow-sm border flex items-center gap-4">
                <div className="w-14 h-14">
                  <CircularProgressbar
                    value={item.percent}
                    text={`${item.percent % 1 === 0 ? item.percent : item.percent.toFixed(2)}%`}
                    styles={buildStyles({
                      pathColor: item.color,
                      textColor: "#000",
                      trailColor: "#e5e7eb",
                      textSize: "22px",
                    })}
                  />
                </div>
                <div>
                  <div className="text-lg font-semibold text-gray-900">
                    {item.value.toLocaleString()}
                  </div>
                  <div className="text-sm text-gray-500">{item.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Filters */}
        <div className="flex justify-between items-center mt-6 mb-6 md:gap-10 gap-6  relative md:flex-row flex-col">
          <div className="flex !w-full items-center gap-2 md:flex-row flex-col">
            <div className="relative md:w-60 w-full">
              <TextInput
                name="serialNumber"
                placeholder="TagRefId / Batch ID"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
                inputClass="pr-16 py-[12.5px] text-sm"
              />
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 flex items-center">
                <Search className="w-4 h-4" />
                <QrCode className="w-6 h-6 ml-2 cursor-pointer text-[#EF4444]" data-testid="qr-code-icon" onClick={() => setScannerOpen(true)} />
              </div>
            </div>

            <div className="w-relative md:w-60 w-full ">
              <CustomSelectInput
                name="selectedVehicleClass"
                value={selectedVehicleClass}
                onChange={(e) => setSelectedVehicleClass(e.target.value)}
                options={[
                  { name: "All Vehicle Classes", value: "" },
                  ...vehicleClasses.map((vehicle) => ({
                    name: vehicle.value,
                    value: vehicle.value,
                    tagimage: vehicle.tagimage
                  }))
                ]}
                inputClass="py-[12.5px] px-3 text-sm !text-gray-400"
              />
            </div>

            <div className="relative md:w-40 w-full">
              <CustomSelectInput
                name="ActivationStatus"
                value={activationFilter}
                onChange={(e) => {
                  setActivationFilter(e.target.value);
                  setCurrentPage(1);
                }}
                options={[
                  { name: "Status", value: "" },
                  { name: "Active", value: "true" },
                  { name: "Inactive", value: "false" },
                ]}
                inputClass="py-[12.5px] px-3 text-sm !text-gray-400"
              />
            </div>

            {/* <div className="w-60 ">
              <CustomSelectInput
                name="selectedAgent"
                value={selectedAgent}
                onChange={(e) => setSelectedAgent(e.target.value)}
                options={[{ name: "All Agents", value: "" }, ...agentNames.map((name) => ({ name, value: name }))]}
                inputClass="py-[12.5px] px-3 text-sm !text-gray-400"
              />
            </div> */}
          </div>

          <div>
            <button
              className="w-full bg-green-500 hover:bg-green-600 text-white py-[11px] rounded-full px-[37px] font-medium flex items-center justify-center space-x-2 transition-colors"
              onClick={() => setShow(true)}

            >
              <span className="xl:text-[14px] text-[14px] font-[700]">Raise FASTag Request</span>
              <ArrowRight className="!w-[16px] !h-[16px]" />
            </button>
          </div>
        </div>


        {/* Table */}
        <CommonTable
          loading={checkInventoryAgent}
          columns={tableColumns}
          data={inventoryData || []}
          emptyMessage="No inventory Found"
          // onRowClick={handleRowClick}
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
          currentPage={currentPage}
          isPagination={true}
          itemsPerPage={itemsPerPage}
          tableData={GetInventoryAgent?.data?.data}
          total={GetInventoryAgent?.data?.pagination?.total}
          totalPages={Math.ceil(GetInventoryAgent?.data?.pagination?.total / itemsPerPage)}
          hideDateAndDownload={false}
          onDownload={handleDownload}
          downloading={isDownloading}
        />
        {/* Modal for Desktop */}
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {show && <AgentFastagRequest onClose={() => setShow(false)} />}
      <QRScannerModal
        open={isScannerOpen}
        onClose={() => setScannerOpen(false)}
        onScan={handleScan}
      />
      {selectedTagRefId && (
        <TagCostInfoModal
          tagRefId={selectedTagRefId}
          isActivated={selectedTagActivated}
          initialTab={modalInitialTab}
          onClose={() => { setSelectedTagRefId(null); setSelectedTagActivated(false); }}
        />
      )}
    </>
  );
};

export default AgentInventory;
